const navMenu = {
    navbar: null,

    init() {
        let self = this;
        self.navbar = document.querySelector('.c-navbar-wrapper');

        if(self.navbar) {
            self._menuButtonsBehaviour();
        }
    },

    closeMenu() {

        let menu = document.querySelector('.c-navbar-wrapper');
        let btn = document.querySelector('.js-navbar-btn');

        menu.classList.remove('block');
        btn.classList.remove('open')
    },

    _menuButtonsBehaviour() {
        let self = this;
        let menuButton = document.querySelector('.js-navbar-btn');
        self.menuBtnRef = self._toggleMenu.bind(null, self, menuButton);
        menuButton.addEventListener('click', self.menuBtnRef, null);
        self.menuItemsArray = [];

        let menuItems = self.navbar.querySelectorAll('.c-navbar__item-btn');

        menuItems.forEach((menuItem, index) => {
            self.menuItemsArray[index] = menuItem.addEventListener('click', self._toggleMenuItem, null);
        });
    },

    _toggleMenu(self, menuButton) {
        self.navbar.classList.toggle('block');
        menuButton.classList.toggle('open');
        
    },

    _toggleMenuItem() {
        let dropDown = this.closest('.c-navbar__item').querySelector('.c-navbar__dropdown');
        this.classList.toggle('rotate');
        dropDown.classList.toggle('block');
    },
};

window.navMenu = navMenu;

window.navMenu.init();

document.body.classList.add('body--navbar-submenu-viewable');

document.addEventListener('LokiRequestStart', () => {
    document.body.classList.remove('body--navbar-submenu-viewable');
});

document.addEventListener('LokiRequestEnd', function () {
    window.navMenu.init();

    if(window.innerWidth >= 1200) {
        setTimeout(() => {
            let hoverItem = document.querySelector('.c-navbar__item:hover');
            if (! hoverItem) {
                document.body.classList.add('body--navbar-submenu-viewable');

                return;
            }

            hoverItem.addEventListener('mouseleave', function() {
                document.body.classList.add('body--navbar-submenu-viewable');
            }, {
                once: true,
            });
        }, 1);
    }

   
});



